import getAxiosInstance from '../../helpers/get_axios_instance'
import Axios from 'axios'

class ControlTurno {
  getControlTurno () {
    const axios = getAxiosInstance()
    // Obtiene la lista de camiones sin turno
    const promise = axios.get(`/consulta_cola_sin_control_turno`)
    return promise.then((result) => {
      const { data } = result
      if (data.estado !== 'exito') throw new Error('No se pudo obtener el listado de camiones.')
      return data
    })
  };

  setControlDeTurnos (cpseleccionada) {
    const axios = getAxiosInstance()
    // Elimina una cp de la cola sin turno
    var promise = []
    if (cpseleccionada.length > 0) {
      for (var i = 0, len = cpseleccionada.length; i < len; i++) {
        const cpa = `{"clave":{"numero":" ${cpseleccionada[i]}"}}`
        promise.push(axios.delete(`/colasincontrolturno?r=${cpa}`))
      }
      return Axios.all(promise)
        .then((responses) => {
          responses.map(response => {
            if (response.data.estado !== 'exito') throw new Error('No se pudo completar la operacion de Control de Turno.')
            return response.data.estado
          })
        })
        .catch((err) => {
          console.log('Error', err)
        })
    }
  }
}

export default ControlTurno
